import { init, register } from "../app";
import Timeout from "../component/Timeout";
import ajaxFetch from "../fn/ajax-fetch";
import serializeForm from "../fn/serialize-form";

const selector = "form[data-refresh][data-refresh-container]";

register(container => {
    container.querySelectorAll<HTMLFormElement>(selector).forEach(form => {
        const target = document.querySelector<HTMLElement>(form.dataset.refreshContainer!)!;
        const url = form.dataset.refresh!;

        let page = parseInt(target.querySelector<HTMLElement>(".pagination a.active[data-page]")?.dataset.page ?? "", 10) || 1;
        let limit = parseInt(target.querySelector<HTMLElement>(".custom-pagination .custom-pagination-right button[data-limit]")?.dataset.limit ?? "", 10) || 50;
        let sort: string | null = null;
        let direction: string | null = null;

        let controller: AbortController | null = null;
        let signature: string | null = null;
        const ti = new Timeout(500);

        // submit
        const submit = () => {
            const filters: Record<string, unknown> = serializeForm(form);

            // ajax call
            filters.page = page;
            filters.limit = limit;

            if (sort && direction) {
                filters.sort = sort;
                filters.direction = direction;
            }

            // avoid double calls
            const s = JSON.stringify(filters);
            if (signature !== s) {
                signature = s;

                if (controller) {
                    controller.abort();
                }

                controller = new AbortController();
                const params = new URLSearchParams(filters as Record<string, string>).toString();
                ajaxFetch(`${url}?${params}`, { signal: controller.signal })
                    .then(response => response.text())
                    .then(html => {
                        controller = null;
                        target.innerHTML = html; // trusted server HTML response
                        init(target);
                    })
                    .catch(err => {
                        if ("AbortError" !== (err as Error).name) {
                            throw err;
                        }
                    });
            }
        };

        // reset pagination and submit
        const setFirstPageAndSubmit = () => {
            page = 1;
            submit();
        };

        // pagination event handlers
        target.addEventListener("click", e => {
            const el = (e.target as HTMLElement).closest<HTMLElement>(".pagination a[data-page]");
            if (el) {
                e.preventDefault();
                page = parseInt(el.dataset.page!, 10);
                submit();
            }
        });

        // limitation event handlers
        target.addEventListener("click", e => {
            const el = (e.target as HTMLElement).closest<HTMLElement>(".limitation a[data-limit]");
            if (el) {
                e.preventDefault();
                limit = parseInt(el.dataset.limit!, 10);
                setFirstPageAndSubmit();
            }
        });

        // sort event handlers
        target.addEventListener("click", e => {
            const el = (e.target as HTMLElement).closest<HTMLElement>("a[data-paginator-sort][data-paginator-direction]");
            if (el) {
                e.preventDefault();
                sort = el.dataset.paginatorSort!;
                direction = el.dataset.paginatorDirection!;
                setFirstPageAndSubmit();
            }
        });

        // form event handlers
        form.addEventListener("submit", e => {
            e.preventDefault();
            submit();
        });
        form.addEventListener("change", e => {
            if ((e.target as HTMLElement).matches("select, input[type=checkbox], input[type=radio], input[type=date]")) {
                setFirstPageAndSubmit();
            }
        });
        form.addEventListener("keyup", e => {
            if ((e.target as HTMLElement).matches("input") && 13 !== (e as KeyboardEvent).which) {
                ti.run(setFirstPageAndSubmit);
            }
        });
        form.addEventListener("changeDate", e => {
            if ((e.target as HTMLElement).matches("input.datepicker")) {
                setFirstPageAndSubmit();
            }
        });
    });
});
